import React, { useRef, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import UserSelect from "./UserSelect";
import TabMenu from "./TabMenu";
import BurgerMenu from "./BurgerMenu";
import { users } from "../json";
import useFetchItems from "../hooks/useFetchItems";
import useOnClickOutside from "../hooks/useOnClickOutside";

const NavbarTab = styled.div`
  width: 175px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e5e5e5;
  font-weight: 600;
  font-size: 19px;
  cursor: pointer;
  text-transform: uppercase;

  &:hover {
    opacity: 0.9;
  }

  ${({ theme }) =>
    theme.screenWidth < 1080 &&
    css`
      width: 120px;
    `}
`;

const Navbar = styled.div`
  height: 70px;
  display: flex;
  background: #2c2e30;
  align-items: center;
  border-bottom: 3px solid #e5e5e5;
  margin-bottom: 25px;

  .users-select__menu {
    z-index: 3 !important;
  }

  ${({ theme }) =>
    theme.screenWidth < 600 &&
    css`
      height: 50px;
      margin-bottom: 15px;

      .users-select__control {
        min-height: 30px;
        height: 30px;
        font-size: 13px;
      }

      .users-select__indicator {
        padding: 3px;
      }
    `}
`;

const UsersSelectWrap = styled.div`
  margin-left: auto;
  margin-right: 30px;
  width: 300px;
  ${({ theme }) =>
    theme.screenWidth < 800 &&
    css`
      margin-right: 15px;
    `}
`;

const ContentMask = styled.div`
  opacity: 0.4;
  position: fixed;
  background: black;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
`;

const NavBar = ({ screenWidth }) => {
  const burgerMenu = useRef();
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
  useOnClickOutside(burgerMenu, () => setIsBurgerMenuOpen(false));

  useEffect(() => {
    document.body.style.overflow = isBurgerMenuOpen ? "hidden" : "unset";
  }, [isBurgerMenuOpen]);

  const tabs = [
    { title: "Home" },
    { title: "New" },
    {
      title: "Tags",
      menuItems: useFetchItems("Tags").map((item) => item.game_tag),
      isMenu: true,
    },
    {
      title: "Categories",
      menuItems: useFetchItems("Categories").map((item) => item.category),
      isMenu: true,
    },
  ];

  return (
    <Navbar data-test="navbar">
      {screenWidth > 700 ? (
        tabs.map((item) =>
          item.isMenu ? (
            <TabMenu
              key={item.title}
              title={item.title}
              menuItems={item.menuItems}
            ></TabMenu>
          ) : (
            <NavbarTab data-test="nav-tab" key={item.title}>
              {item.title}
            </NavbarTab>
          ),
        )
      ) : (
        <>
          {isBurgerMenuOpen && <ContentMask data-test="content-mask" />}
          <BurgerMenu
            isOpen={isBurgerMenuOpen}
            setIsOpen={setIsBurgerMenuOpen}
            ref={burgerMenu}
            items={tabs}
          ></BurgerMenu>
        </>
      )}
      <UsersSelectWrap data-test="user-select-wrap">
        <UserSelect options={users} />
      </UsersSelectWrap>
    </Navbar>
  );
};
export default NavBar;
